/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const userListConfig = {
  url: 'https://kali-dev-dc.vlinder.io/digicert/user/find',
  bulkOptions: [
    {
      value: 'reset_password',
      label: 'Reset Password',
    },
    {
      value: 'delete_user',
      label: 'Delete User',
    },
    {
      value: 'suspend_user',
      label: 'Suspend User',
    },
    {
      value: 'invite_user',
      label: 'Invite User',
    },
  ],
  ultTableHeader: ['Name', 'Date Created', 'Verified', 'Status', 'Action'],
  ultUsers: [
    {
      id: '1',
      verified: true,
      status: 'active',
      name: 'Kaliraj Subra Manian',
      email: 'kali@vlinder.io',
      image: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.photos/kali.png',
      role: ['Master Admin', 'admin'],
      dateCreated: '22 July 2022',
    },
    {
      id: '2',
      verified: true,
      status: 'active',
      name: 'Malini Srinivasan',
      email: 'malini@vlinder.io',
      role: 'admin',
      dateCreated: '20 July 2022',
    },
    {
      id: '3',
      verified: true,
      status: 'active',
      name: 'Madhusudhan Srinivasan',
      email: 'madhu@vlinder.io',
      image: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.photos/madhu.png',
      role: 'admin',
      dateCreated: '18 July 2022',
    },
    {
      id: '4',
      verified: false,
      status: 'suspended',
      name: 'vlinder Developer',
      email: 'developer@vlinder.io',
      role: 'admin',
      dateCreated: '22 July 2022',
    },
  ],
  currentPage: 1,
  pageSize: 10,
  totalCount: 4,
  totalPages: 1,
  activePage: 1,
  role: 'admin',
};
